export default function cancelAllUploads(items: UploadManagerItem[], setItemFn: (item: UploadManagerItem) => void) {
  const inProgress = items.filter((i) => i.status === 'uploading');

  inProgress.forEach((i) => {
    if (i.type === 'recording') {
      i.cancelUpload?.();
    }
  });

  items
    .filter(({ status }) => ['queued', 'uploading', 'errored'].includes(status))
    .forEach((i) => {
      try {
        setItemFn({ ...i, status: 'canceled' });
      } catch (error) {
        console.error('Error setting item status to canceled', error);
      }
    });
}
